/**
 * This is an array filtering function
 * @param {Array} list `REQUIRED`
 * @param {String} sortByName `REQUIRED` The name or parameter that will become the main filter identifier
 * @param {String} findByName `REQUIRED` The name of the field or parameter to sort
 */
export const arrayFilter = (list, sortByName, findByName, listName = 'list') => {
  return new Promise((resolve, reject) => {
    try {
      const newList = []
      if (list && list.length) {
        return list.forEach((item, index) => {
          const foundIndex = newList.findIndex(i => i[sortByName] === item[findByName])
          if (foundIndex !== -1) { newList[foundIndex][listName].push(item) } else { newList.push({ [sortByName]: item[findByName], [listName]: [item] }) }
          if (index === list.length - 1) { resolve(newList) }
        })
      } else resolve(list)
    } catch (error) {
      reject(error)
    }
  })
}
